import ServiceClient from '../ServiceClient'
import { BASE_PATH } from './consts'

export type QueryBulasRequest = Partial<{
    principios: string[]
    reacoes: string[]
    fabricantes: string[]
    medicamentos: string[]
}>

export type QueryBulasResponse = {
    duration: number
    dominios: {
        fabricantes: DominioBean[]
        medicamentos: DominioBean[]
        principiosAtivos: DominioBean[]
        reacoes: DominioBean[]
    }
    totais: {
        qtdeFabricates: number
        qtdeCoberturasCompletas: number
        qtdeCoberturaParciais: number
        qtdeNaoDocumentadas: number
    }
    relation: ReBulaFaricanteMedicamentoReacaoes[]
}

export type DominioBean = {
    id: string
    nome: string
}

export type ReBulaFaricanteMedicamentoReacaoes = [
    string,               // idFabricante
    [
        string,             // idMedicamento
        number[]            // idReacoes
    ]
];

let TASK_MAP = new Map<string, Promise<QueryBulasResponse>>()

export default async (rq: QueryBulasRequest): Promise<QueryBulasResponse> => {
    const taskKey = JSON.stringify(rq)

    let runningTask = TASK_MAP.get(taskKey)
    if (runningTask) {
        return await runningTask
    }

    let doResolve: (tgtData: QueryBulasResponse) => void = () => void 0
    let doReject: (error: unknown) => void = () => void 0
    runningTask = new Promise<QueryBulasResponse>((resolve, reject) => {
        doResolve = resolve
        doReject = reject
    })

    TASK_MAP.set(taskKey, runningTask)
    try {
        const url = ServiceClient.newUrl(`${BASE_PATH}/reacoes`)
        arrayIsNotEmpty(rq.principios) && (url.searchParams.append('principios', rq.principios.join(',')))
        arrayIsNotEmpty(rq.reacoes) && (url.searchParams.append('reacoes', rq.reacoes.join(',')))
        arrayIsNotEmpty(rq.fabricantes) && (url.searchParams.append('fabricantes', rq.fabricantes.join(',')))
        arrayIsNotEmpty(rq.medicamentos) && (url.searchParams.append('medicamentos', rq.medicamentos.join(',')))
        const response = await ServiceClient.authGet(url) as QueryBulasResponse
        doResolve(response)
        return response
    } catch (error) {
        doReject(error)
        throw error
    } finally {
        TASK_MAP.delete(taskKey)
    }
}

function arrayIsNotEmpty(arr: unknown[]) {
    return arr ? arr.length > 0 : false
}